import React from "react"
import styled from "styled-components"
import { FlexSearchInput } from "../FlexSearchInput"

export const DesktopHeaderSearch = ({ searchedString, setSearchedString }) => {
  return (
    <DesktopSearchInputWrapper>
      <DesktopHeaderSearchInput
        input={searchedString}
        onChange={setSearchedString}
        floatingResults
      />
    </DesktopSearchInputWrapper>
  )
}

const DesktopHeaderSearchInput = styled(FlexSearchInput)`
  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    flex: 1 1 auto;
  }
}
`

const DesktopSearchInputWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.media.desktop_min}) {
    display: block;
  }
}
`
